function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12ZM13.937 12.5H15.9691C15.878 13.2304 15.59 13.8996 15.1599 14.4528L13.7231 13.016C13.8171 12.8568 13.8898 12.6835 13.937 12.5ZM13.016 13.7231L14.4528 15.1599C13.8996 15.59 13.2304 15.878 12.5 15.9691V13.937C12.6835 13.8898 12.8568 13.8171 13.016 13.7231ZM11.5 13.937V15.9691C10.7696 15.878 10.1004 15.59 9.54718 15.1599L10.984 13.7231C11.1432 13.8171 11.3165 13.8898 11.5 13.937ZM10.2769 13.016L8.84007 14.4528C8.40999 13.8996 8.12202 13.2304 8.03095 12.5H10.063C10.1102 12.6835 10.1829 12.8568 10.2769 13.016ZM13.937 11.5H15.9691C15.878 10.7696 15.59 10.1004 15.1599 9.54718L13.7231 10.984C13.8171 11.1432 13.8898 11.3165 13.937 11.5ZM12.5 8.03095C13.2304 8.12202 13.8996 8.40999 14.4528 8.84007L13.016 10.2769C12.8568 10.1829 12.6835 10.1102 12.5 10.063V8.03095ZM11.5 8.03095V10.063C11.2972 10.1152 11.1069 10.1984 10.9344 10.3072L9.32872 9.02266C9.92014 8.49168 10.6706 8.13437 11.5 8.03095ZM8.67297 9.77869L10.2464 11.0375C10.1671 11.1817 10.105 11.3368 10.063 11.5H8.03095C8.10966 10.8688 8.33546 10.2832 8.67297 9.77869ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 12C19.5 7.85786 16.1421 4.5 12 4.5V3.5C16.6944 3.5 20.5 7.30558 20.5 12H19.5Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12 19.5C7.85786 19.5 4.5 16.1421 4.5 12H3.5C3.5 16.6944 7.30558 20.5 12 20.5V19.5Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
  fill: "white"
});

function SvgFooterWheelTire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterWheelTire);
export default __webpack_public_path__ + "static/media/footer-wheel-tire.3361b037.svg";
export { ForwardRef as ReactComponent };